import React from 'react'
import LegendDonut from '../../common/LegendDonut'

const SOURCE_COLORS = ['#266ef1', '#abd575']

const OrderedStylesBySource = ({ sourcingData }) => {
    const items = [
        {
            label: 'Nitex design',
            value: sourcingData?.nitexDesignPercentage ?? 0,
            count: sourcingData?.nitexDesignStyleCount ?? 0,
            color: SOURCE_COLORS[0]
        },
        {
            label: 'Development',
            value: sourcingData?.buyerDesignPercentage ?? 0,
            count: sourcingData?.buyerDesignStyleCount ?? 0,
            color: SOURCE_COLORS[1]
        }
    ]

    return <LegendDonut items={items} hideTooltipLabel chartSize={80} />
}

export default OrderedStylesBySource
